"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const failedParseObject_1 = require("../helpers/failedParseObject");
const successfulParse_1 = require("../helpers/successfulParse");
const big_js_1 = __importDefault(require("big.js"));
const missingValueError_1 = require("../helpers/missingValueError");
exports.parseBig = (value, key) => {
    if (value === null || value === undefined) {
        return missingValueError_1.missingValueError(key);
    }
    if (typeof value !== "string") {
        return failedParseObject_1.failedParseObject(key);
    }
    try {
        const big = new big_js_1.default(value);
        return successfulParse_1.successfulParse(big);
    }
    catch (_a) {
        return failedParseObject_1.failedParseObject(key);
    }
};
exports.parseOptionalBig = (value, key) => {
    if (value === null || value === undefined) {
        return successfulParse_1.successfulParse(undefined);
    }
    return exports.parseBig(value, key);
};
//# sourceMappingURL=parseBig.js.map